<template>
  <div class="mainbody">
    <div id="app" v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统功能</el-breadcrumb-item>
          <el-breadcrumb-item>菜单导航</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="linkUrlAdd"
                v-if="flagAdd"
                >新增</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-delete"
                @click="deleteCheckAll"
                style="display: none"
                >删除</el-button
              >
            </el-button-group>
          </div>
          <div class="r-list">
            <div class="search-box">
              <el-input placeholder="输入关健字" v-model="keyword">
                <el-button
                  type="primary"
                  slot="append"
                  icon="el-icon-search"
                  @click="initData"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            row-key="id"
            default-expand-all
            stripe
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column
              prop="title"
              label="标题"
              min-width="160"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="标识"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="sortId"
              label="排位"
              min-width="120"
            ></el-table-column>
            <el-table-column
              prop="linkUrl"
              label="链接"
              min-width="150"
            ></el-table-column>
            <el-table-column
              prop="status"
              label="显示"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <i class="el-icon-check" v-if="scope.row.status == 0"></i>
                <i class="el-icon-close" v-else></i>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="130">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-edit"
                  v-if="flagUpdate"
                  @click="linkUrl(scope.row.id)"
                ></el-button>
                <el-button
                  size="mini"
                  icon="el-icon-plus"
                  v-if="flagAdd"
                  @click="linkUrlEtid(scope.row.id)"
                ></el-button>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  v-if="flagDel"
                  @click="deleteItem(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax } from "../../js/axios.config";
export default {
  data() {
    return {
      loading: false,
      keyword: "",
      listData: [],
      flagAdd: false,
      flagDel: false,
      flagDel: false,
      flagUpdate: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "系统中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "菜单配置");
        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },
    //加载数据
    initData: function () {
      let _this = this;
      // let sendUrl = "/cabinet/navigation/getList";
      let sendUrl = "/cabinet/navigation/v2/getList";
      if (_this.keyword.length > 0) {
        sendUrl += "?keyword=" + encodeURI(_this.keyword);
      }
      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data;
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //跳转链接
    linkUrl: function (url) {
      this.$router.push({ name: "NavEdit", query: { id: url } });
    },
    //跳转链接
    linkUrlAdd: function (url) {
      this.$router.push({ name: "NavEdit" });
    },
    //跳转链接
    linkUrlEtid: function (url) {
      this.$router.push({ name: "NavEdit", query: { parentId: url } });
    },
    //多选删除
    deleteCheckAll: function () {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //拿到选中的数据
      let list = _this.multipleSelection;
      //检查是否有选中
      if (list.length == 0) {
        _this.$message({ type: "warning", message: "请选择要删除的记录！" });
        return false;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/navigation?ids=" + list.toString(),
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              //_this.$refs.treeList.setCheckedKeys([]); //清除选中状态
              _this.initData(); //重新加载列表
              if (parent.vm) parent.vm.initData(); //重新加载菜单
            },
          });
        })
        .catch(function () {});
    },
    //单项删除
    deleteItem: function (val) {
      let _parent = this; //父页面
      let _this = this; //当前页面
      //判断是否有父窗体
      if (typeof parent.vm != "undefined") {
        _parent = parent.vm;
      }
      //执行删除操作
      _parent
        .$confirm("确认要删除该记录吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(function () {
          AxiosAjax({
            method: "delete",
            url: "/cabinet/navigation/" + val,
            data: { id: val },
            loading: true,
            successMsg: "已删除成功",
            success: function (res) {
              _this.initData(); //重新加载列表
              if (parent.vm) parent.vm.initData(); //重新加载菜单
            },
          });
        })
        .catch(function () {});
    },
    //选中第几行
    handleSelectionChange: function (val) {
      if (val.length > 0) {
        let idsArr = [];
        val.forEach(function (item, index) {
          idsArr.push(item.id);
        });
        this.multipleSelection = idsArr;
      }
    },
  },
  created: function () {
    //加载数据
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Setting/NavList.vue